import React, { useState, useContext, useEffect } from "react";

import { Link, Redirect, withRouter, useLocation } from "react-router-dom";

import PsContext from "../../context";
import { Card, Col, Form, Row, Button } from "react-bootstrap";
import { LOGIN_FOR, LOGIN_FOR_MBA } from "../../utils/data";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import { momentDate, S3_BUCKET_HOME_PATH } from "../../utils";
import { toast } from "react-hot-toast";
import { Spin } from "antd";

const LoginForm = (props) => {
  const context = useContext(PsContext);
  //console.log(context.settings);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [captcha, setCaptcha] = useState([]);
  const [toVerify, setToVerify] = useState(false);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const type = params.get("type");

  useEffect(() => {
    loadCaptcha();
  }, []);

  const loadCaptcha = () => {
    setLoader(true);
    axios.get(ServiceUrl.ADMISSION.CAPTCHA).then((res) => {
      if (res["data"].status == "1") {
        setCaptcha(res["data"]);
      }
      setLoader(false);
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    axios
      .post(ServiceUrl.ADMISSION.LOGIN, new FormData(form))
      .then((res) => {
        if (res["data"].status == "1") {
          axios.defaults.headers.common["Api-Token"] = res["data"].api;
          context.saveLogin(
            res["data"].user,
            res["data"].api,
            "",
            "",
            "",
            res["data"].pgtype,
          );
          context.updateLogged();
          window.location.href = "/";
        } else if (res["data"].status == "2") {
          setToVerify(res["data"].token);
        } else {
          toast.error(res["data"].message || "Error");
          loadCaptcha();
        }
        setLoader(false);
      })
      .catch((er) => {
        setLoader(false);
      });
  };

  if (toVerify)
    return <Redirect to={`/mobile-verification?token=${toVerify}`} />;

  const maxDate = (type) => {
    if (type == "UG") {
      let y = momentDate(new Date(), "YYYY") - 15;
      let d = momentDate(new Date(), "DD");
      let m = momentDate(new Date(), "MM");
      return momentDate(y + "-" + m + "-" + d, "YYYY-MM-DD");
    } else {
      let y = momentDate(new Date(), "YYYY") - 15;
      let d = momentDate(new Date(), "DD");
      let m = momentDate(new Date(), "MM");
      return momentDate(y + "-" + m + "-" + d, "YYYY-MM-DD");
    }
  };

  const academicYear = context.settingValue("current_academic_year");

  return (
    <Card className="rounded-2 border-0 shadow card-login h-100 overflow-hidden d-flex flex-column">
      <div className="bg-main-theme" style={{ height: "3px" }}></div>
      <Card.Body className="p-4 d-flex flex-column">
        <div className="text-center mb-4 pb-2 border-bottom">
          <h6 className="fw-800 text-dark mb-0 fs-15 pb-1 text-uppercase">
            ADMISSIONS OPEN {academicYear}
          </h6>
        </div>

        <Spin
          spinning={loader}
          className="flex-grow-1 d-flex flex-column justify-content-center"
        >
          <Form
            action=""
            method="post"
            noValidate
            validated={validated}
            onSubmit={handleFormSubmit}
          >
            <input type="hidden" name="i__captchaCode" value={captcha.code} />

            <div
              className="d-flex justify-content-between border-bottom border-light"
              style={{ marginBottom: "15px", paddingBottom: "10px" }}
            >
              {(S3_BUCKET_HOME_PATH == "xiba/" ? LOGIN_FOR_MBA : LOGIN_FOR).map(
                (item) =>
                  context.settingValue(item.key) == "1" && (
                    <Form.Check
                      key={item.value}
                      type="radio"
                      id={`radio-${item.value}`}
                      className="custom-radio-theme fs-13 fw-600"
                      style={{ marginRight: "4px" }}
                      name="i__loginFor"
                      value={item.value}
                      defaultChecked={item.value == "ug" ? true : false}
                      required
                      label={item.text}
                    />
                  ),
              )}
            </div>

            <Form.Group className="mb-3 text-start">
              <Form.Label className="fs-12 fw-700 text-dark mb-1">
                Registered Candidate's Mobile Number (or) Email ID
                <span className="text-danger">*</span>
              </Form.Label>
              <div className="custom-floating-wrap">
                <Form.Control
                  id="floatingUser"
                  type="text"
                  name="i__userName"
                  placeholder=" "
                  className="bg-light border custom-floating-input w-100 no-bg-focus rounded-1"
                  required
                  autoComplete="off"
                  autoFocus={true}
                />
                <label htmlFor="floatingUser" className="custom-floating-label">
                  Mobile Number / Email
                </label>
                <Form.Control.Feedback type="invalid">
                  Username is required.
                </Form.Control.Feedback>
              </div>
            </Form.Group>

            <Form.Group className="mb-3 text-start">
              <Form.Label className="fs-12 fw-700 text-dark mb-1">
                Candidate Date of Birth<span className="text-danger">*</span>
              </Form.Label>
              <div className="custom-floating-wrap">
                <Form.Control
                  id="floatingDob"
                  type="date"
                  name="i__dob"
                  placeholder=" "
                  className="bg-light border custom-floating-input w-100 no-bg-focus rounded-1"
                  max={maxDate(type)}
                  min={type == "UG" ? "2002-06-01" : "1960-06-01"}
                  required
                />
                <label htmlFor="floatingDob" className="custom-floating-label">
                  DOB
                </label>
                <Form.Control.Feedback type="invalid">
                  Date of birth is required.
                </Form.Control.Feedback>
              </div>
            </Form.Group>

            <div
              className="p-2 bg-light border rounded-0"
              style={{ marginBottom: "5px" }}
            >
              <Row className="align-items-center g-2">
                <Col xs={7}>
                  <div className="d-flex align-items-center">
                    <img
                      src={captcha && captcha.img}
                      className="img-fluid border bg-white"
                      alt="captcha"
                      style={{ maxHeight: "28px" }}
                    />
                    <Button
                      type="button"
                      className="ms-2 border-0 bg-transparent text-main-theme p-0"
                      onClick={(e) => loadCaptcha()}
                    >
                      <i className="fa-solid fa-sync fs-14"></i>
                    </Button>
                  </div>
                </Col>
                <Col xs={5}>
                  <div className="custom-floating-wrap">
                    <Form.Control
                      id="floatingCaptcha"
                      type="text"
                      name="i__captcha"
                      required
                      placeholder=" "
                      className="border-0 border-bottom rounded-0 bg-transparent text-center custom-floating-input w-100 no-bg-focus"
                      style={{ height: "38px", padding: "18px 4px 2px 4px" }}
                      autoComplete="off"
                    />
                    <label
                      htmlFor="floatingCaptcha"
                      className="custom-floating-label w-100 text-center"
                      style={{ left: 0, top: "10px" }}
                    >
                      Code
                    </label>
                  </div>
                </Col>
              </Row>
            </div>

            <div className="mt-3">
              <Button
                type="submit"
                size="sm"
                className="w-100 btn-main-theme-solid border-0 fs-14 text-white fw-bold shadow-sm"
                style={{ paddingTop: "10px", paddingBottom: "10px" }}
              >
                <i className="fa-solid fa-right-to-bracket me-2 small"></i>
                SIGN IN
              </Button>
            </div>

            <div className="mt-3 text-center fs-12 text-muted fw-600">
              New Applicant?{" "}
              <Link
                to="/sign-up"
                className="text-main-theme text-decoration-none border-bottom border-main-theme border-opacity-25 pb-1 hvr-underline"
              >
                Create Account
              </Link>
            </div>
          </Form>
        </Spin>
      </Card.Body>
    </Card>
  );
};

export default LoginForm;
